<template>
    <div class="announcementList">
        <div class="title">
            <div class="title-text">{{$t('LatestAnnouncement')}}</div>
            <el-button size="mini" @click="back">{{$t('back')}}</el-button>
        </div>
        <div class="content">
            <div class="item-box" v-for="(item, index) in articleList" :key="index" @click="articleDetail(item)">
                <div class="title">{{item.title}}</div>
                <div class="date">{{item.crtTime}}</div>
            </div>
        </div>
        <div class="block">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-size="limit"
                layout="prev, pager, next"
                :prev-text="$t('PreviousPage')"
                :next-text="$t('NextPage')"
                :total="total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import { getLatestAnnouncement } from '@/api/buyTicket'
export default {
  name: 'announcementList',
  data () {
    return {
      articleList: null,
      total: 0,
      page: 1,
      limit: 15
    }
  },
  created () {
    this.getCategory()
  },
  methods: {
    getCategory () {
      getLatestAnnouncement({
        'categoryCode': 'LATESTANNOUNCEMENT',
        'clientSide': 'ALL',
        'limit': this.limit,
        'page': this.page,
        'status': 'T',
        'languages': localStorage.getItem('languageCode') || 'Simplified_Chinese'
      }).then(res => {
        if (res.code === 0) {
          this.articleList = res.data.list
          this.total = res.data.totalCount
        }
      })
    },
    articleDetail (item) {
      this.$router.push({
        path: '/articleDetail',
        query: {
          item: JSON.stringify(item)
        }
      })
    },
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange (val) {
      this.page = val
      this.getCategory()
    },
    back () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.announcementList {
    width: 1100px;
    margin: 0 auto;
    background-color: white;
    min-height: 520px;
    padding: 30px 90px;
    .title {
        display: flex;
        justify-content: space-between;
        margin-bottom: 62px;
        .title-text {
            font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            line-height: 26px;
            color: #424855;
            opacity: 1;
        }

    }
    .item-box {
        display: flex;
        justify-content: space-between;
        height: 33px;
        cursor: pointer;
        .title {
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 20px;
            color: #0C121D;
            opacity: 1;
            &::before {
                content: '•';
                font-size: 18px;
                padding-right: 6px;
                color: #A7AEBB;;
            }
            &:hover {
                color: #A0393E;
            }
        }
        .date {
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 20px;
            color: #6A7792;
            opacity: 1;
        }
    }
    .el-pagination {
        text-align: center;
        /deep/ .el-pager li.active {
            background: #A0393E;
            color: #FFFFFF;
        }
        /deep/ span {
            border: 1px solid #AEAFB0;
            border-radius: 4px;
            padding: 0 5px
        }
    }
}
</style>
